<script setup lang="ts">
import { computed } from 'vue'
import { MenubarContent, type MenubarContentProps, MenubarPortal, useForwardProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = withDefaults(defineProps<MenubarContentProps & { class?: string }>(), {
    align: 'start',
})

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
    <MenubarPortal>
        <MenubarContent
            v-bind="forwardedProps"
            :class="
                cn(
                    'hidden md:block',
                    'z-50 w-screen max-h-[calc(100vh-var(--lp-menu-bar-client-type)-var(--lp-menu-bar-desktop))] overflow-auto bg-plus-lp-white text-plus-lp-popover-foreground data-[state=open]:animate-in data-[state=closed]:lp-fade-out-0 data-[state=open]:lp-fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:lp-slide-in-from-top-2 data-[side=left]:lp-slide-in-from-right-2 data-[side=right]:lp-slide-in-from-left-2 data-[side=top]:lp-slide-in-from-bottom-2',
                    props.class,
                )
            "
        >
            <div class="plus-lp-container py-6">
                <slot />
            </div>
        </MenubarContent>
    </MenubarPortal>
</template>
